import { AEMScenes } from '@as-react/common-types';
import { loadSingleProductTileReducer } from '../../single-product-tile/reducers/SingleProductTileReducer';
const loadSingleProductTileDynamicModule = () => ({
    id: AEMScenes.SINGLE_PRODUCT_TILE,
    reducerMap: {
        singleProductsList: loadSingleProductTileReducer,
    },
});
export default loadSingleProductTileDynamicModule;
